import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import '../styles/Pages.css';

function Calls() {
  const [callTemplates, setCallTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [callDetails, setCallDetails] = useState({ name: '', phoneNumber: '' });
  const [script, setScript] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchCallTemplates = async () => {
      try {
        const response = await axiosInstance.get('/api/call-templates');
        setCallTemplates(response.data);
      } catch (err) {
        console.error('Error fetching call templates:', err);
      }
    };

    fetchCallTemplates();
  }, []);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    let populatedScript = template.script;
    for (const placeholder of template.placeholders) {
      const value = callDetails[placeholder] || `[${placeholder}]`;
      populatedScript = populatedScript.replaceAll(`{${placeholder}}`, value);
    }
    setScript(populatedScript);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedDetails = { ...callDetails, [name]: value };
    setCallDetails(updatedDetails);

    if (selectedTemplate) {
      let updatedScript = selectedTemplate.script;
      for (const placeholder of selectedTemplate.placeholders) {
        const val = updatedDetails[placeholder] || `[${placeholder}]`;
        updatedScript = updatedScript.replaceAll(`{${placeholder}}`, val);
      }
      setScript(updatedScript);
    }
  };

  const handleCall = async () => {
    if (!callDetails.phoneNumber || !callDetails.name || !selectedTemplate) {
      setError('Please fill in all fields and select a template.');
      return;
    }

    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await axiosInstance.post('/api/calls/logs', {
        templateId: selectedTemplate._id,
        contactName: callDetails.name,
        contactNumber: callDetails.phoneNumber,
        notes: script,
      });

      console.log('Call logged:', response.data);
      setSuccess('Call logged successfully.');
    } catch (err) {
      console.error('Error logging call:', err);
      setError('Failed to log the call. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <h1>Calls</h1>

      <div className="call-details-container">
        <label>
          Name:
          <input
            type="text"
            name="name"
            value={callDetails.name}
            onChange={handleInputChange}
            placeholder="Enter name"
          />
        </label>
        <label>
          Phone Number:
          <input
            type="tel"
            name="phoneNumber"
            value={callDetails.phoneNumber}
            onChange={handleInputChange}
            placeholder="Enter phone number"
          />
        </label>
      </div>

      <div className="templates-container">
        <h2>Call Templates</h2>
        {callTemplates.length > 0 ? (
          <ul>
            {callTemplates.map((template) => (
              <li key={template._id}>
                <button
                  onClick={() => handleTemplateSelect(template)}
                  className={selectedTemplate?._id === template._id ? 'selected' : ''}
                >
                  {template.name}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p>No templates available.</p>
        )}
      </div>

      <div className="script-container">
        <h2>Script</h2>
        {selectedTemplate ? (
          <textarea value={script} readOnly rows={10}></textarea>
        ) : (
          <p>Select a template to view the script.</p>
        )}
      </div>

      <button onClick={handleCall} disabled={loading}>
        {loading ? 'Logging Call...' : 'Log Call'}
      </button>

      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}
    </div>
  );
}

export default Calls;